var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 10.75V19H1.25V10.75M0.5 4H21.5V10C21.5 10 17 13 11 13C5 13 0.5 10 0.5 10V4ZM11 14.5V11.5V14.5ZM14 4C14 4 14 1 11 1C8 1 8 4 8 4",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 10.75V19H1.25V10.75M11 14.5V11.5M14 4C14 4 14 1 11 1C8 1 8 4 8 4M0.5 4H21.5V10C21.5 10 17 13 11 13C5 13 0.5 10 0.5 10V4Z",
    stroke: "#077255",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioManagement);
export default __webpack_public_path__ + "static/media/portfolioManagement.a2d3def8038472e3286a0beee03fe4b2.svg";
export { ForwardRef as ReactComponent };